import { Client } from 'api/typegen/client/get';
import fetchWebApi from 'api/fetchWebApi';

const getClientApiCall = async (): Promise<Client> => fetchWebApi('/client');

export default getClientApiCall;
